import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "@emotion/styled-base";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getFilters } from "../../../../../../common/config/filters";
import CommonPropTypes from "../../../../../../common/constants/proptypes/CommonPropTypes";
import { shouldFacetProductBeShown } from "../../../../../../common/utils/filters";
import AddonDiscoveryPropTypes from "../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import CurrentFilter from "./CurrentFilter";
export var CurrentFiltersContent = _styled("span", {
  target: "ex5puya0",
  label: "CurrentFiltersContent"
})(process.env.NODE_ENV === "production" ? {
  name: "v7ibj3",
  styles: "display:inline-block;vertical-align:middle;"
} : {
  name: "v7ibj3",
  styles: "display:inline-block;vertical-align:middle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

function resolveCurrentFilters(_ref) {
  var filters = _ref.filters,
      hiddenFilters = _ref.hiddenFilters;
  return filters.filter(function (v, key) {
    return getFilters().has(key) && getFilters().get(key).get('displayInCurrent');
  }).entrySeq().flatMap(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return Immutable.Iterable.isIterable(value) ? value.toList().map(function (v) {
      return Immutable.Map({
        key: key,
        value: v,
        multi: true
      });
    }) : Immutable.List.of(Immutable.Map({
      key: key,
      value: value,
      multi: false
    }));
  }).filter(function (cf) {
    return shouldFacetProductBeShown(cf.get('key'), cf.get('value'), hiddenFilters);
  }).toList();
}

var CurrentFilters = /*#__PURE__*/function (_Component) {
  _inherits(CurrentFilters, _Component);

  var _super = _createSuper(CurrentFilters);

  function CurrentFilters() {
    var _this;

    _classCallCheck(this, CurrentFilters);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentFilters: resolveCurrentFilters({
        filters: _this.props.filters,
        hiddenFilters: _this.props.hiddenFilters
      })
    });

    return _this;
  }

  _createClass(CurrentFilters, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      var filters = newProps.filters,
          hiddenFilters = newProps.hiddenFilters;
      var newCurrentFilters = resolveCurrentFilters({
        filters: filters,
        hiddenFilters: hiddenFilters
      });
      this.setState(function (_ref4) {
        var currentFilters = _ref4.currentFilters;
        return {
          currentFilters: // This ensures that new filters are always at the end
          currentFilters.filter(function (cf) {
            return newCurrentFilters.contains(cf);
          }).concat(newCurrentFilters.filterNot(function (ncf) {
            return currentFilters.contains(ncf);
          }))
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("span", null, this.state.currentFilters.size ? /*#__PURE__*/React.createElement("span", null, "filtered by ") : undefined, /*#__PURE__*/React.createElement(CurrentFiltersContent, null, this.state.currentFilters.map(function (cf) {
        return /*#__PURE__*/React.createElement(CurrentFilter, {
          key: "currentFilter_".concat(cf.get('key'), "_").concat(cf.get('value')),
          filters: _this2.props.filters,
          filterKey: cf.get('key'),
          filterValue: cf.get('value'),
          multi: cf.get('multi'),
          stateChangeRequested: _this2.props.stateChangeRequested
        });
      })));
    }
  }]);

  return CurrentFilters;
}(Component);

_defineProperty(CurrentFilters, "propTypes", {
  filters: CommonPropTypes.filters.isRequired,
  hiddenFilters: AddonDiscoveryPropTypes.hiddenFilters.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
});

export { CurrentFilters as default };